module.exports = __webpack_public_path__ + "static/img/30008 (1).ab376d5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30008 (1).webp
// module id = DVt1
// module chunks = 14